var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mock-exam-entry"},[_vm._v("正在进入模拟考试...")])}
var staticRenderFns = []

export { render, staticRenderFns }